import {Inject, Injectable} from '@angular/core';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';
import {MOMENT_TOKEN} from '../../shared/shared.module';

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  constructor(
    private api: APIHelper,
    @Inject(MOMENT_TOKEN) private moment
  ) {
  }

  public getUserTasks() {
    return this.api.requestApi({action: API_URLS.tasks.getUserTasks});
  }

  public getUserAchievedTasks() {
    const args =
      'properties=bpm_priority,bpm_status,bpm_dueDate,bpm_description&exclude=wcmwf:*&skipCount=0&maxItems=50&pooledTasks=false&state=COMPLETED&pooledTasks=false&state=COMPLETED';
    return this.api.requestApi({
      action: API_URLS.tasks.getUserTasks,
      queryArgs: args
    });
  }

  public getUserTodaysTasks() {
    const dueBefore = this.moment().format('YYYY-MM-DD[T]') + '11:59:59.999+01:00';
    const dueAfter =
      this.moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD[T]') + '11:59:59.999+01:00';
    const args =
      'properties=bpm_priority,bpm_status,bpm_dueDate,bpm_description&exclude=wcmwf:*&skipCount=0&maxItems=50&dueAfter=' +
      dueAfter +
      '&dueBefore=' +
      dueBefore +
      '&dueAfter=' +
      dueAfter +
      '&dueBefore=' +
      dueBefore +
      '';
    return this.api.requestApi({
      action: API_URLS.tasks.getUserTasks,
      queryArgs: args
    });
  }

  public getUserLateTasks() {
    const dueBefore =
      this.moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD[T]') + '11:59:59.999+01:00';

    const args =
      'properties=bpm_priority,bpm_status,bpm_dueDate,bpm_description&exclude=wcmwf:*&skipCount=0&maxItems=50&dueBefore=' +
      dueBefore +
      '&dueBefore=' +
      dueBefore +
      '';
    return this.api.requestApi({
      action: API_URLS.tasks.getUserTasks,
      queryArgs: args
    });
  }

  public getUserDateTasks(begin, end) {
    const args =
      'properties=bpm_priority,bpm_status,bpm_dueDate,bpm_description&exclude=wcmwf:*&skipCount=0&maxItems=50&dueAfter=' +
      begin +
      '&dueBefore=' +
      end +
      '&dueAfter=' +
      begin +
      '&dueBefore=' +
      end +
      '';
    return this.api.requestApi({
      action: API_URLS.tasks.getUserTasks,
      queryArgs: args
    });
  }
}
